import React, { useState, useEffect } from 'react';
import "../styles/TaskDetails.css";
import { getPhotos } from '../modules/fetchData';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faCheck } from "@fortawesome/free-solid-svg-icons";
import { API_BASE_URL } from '../config';

function TaskDetails({ taskId, task, subTasks }) {
    let savedUser = JSON.parse(localStorage.getItem('user'));
    const [filteredPhotos, setFilteredPhotos] = useState(new Map());

    const filteredSubTasks = subTasks.filter(subTask => subTask.done === null);

    useEffect(() => {
        async function fetchMaterials() {
            try {
                const photosData = await getPhotos();

                const photosMap = new Map();

                filteredSubTasks.forEach(subTask => {
                    const photo = photosData.find(photo => {
                        const [, subtaskIdFromName] = photo.name.split("_");
                        return subtaskIdFromName === String(subTask.id);
                    });
                    if (photo) {
                        photosMap.set(subTask.description, { subTaskId: subTask.id, photo: photo, subTask: subTask });
                    }
                });

                setFilteredPhotos(photosMap);

            } catch (error) {
                console.error('Error fetching materials:', error);
            }
        }

        fetchMaterials();
    }, [taskId, filteredSubTasks]);

    const finishTask = async () => {
        try {
            let savedUser = JSON.parse(localStorage.getItem('user'));
            const response = await fetch(`${API_BASE_URL}/api/v1/task/done/${taskId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization":`Bearer ${savedUser["jwtToken"]}`
                },
            });

            if (!response.ok) {
                throw new Error("Failed to finish task");
            }

            console.log(`Task ${taskId} has been finished`);
        } catch (error) {
            console.error("Error finishing task:", error);
        }
    };

    const updateSubTaskStatus = async (subTaskId, subTask, isApproved) => {
        try {
            let savedUser = JSON.parse(localStorage.getItem('user'));
            subTask.done = isApproved;
            const response = await fetch(`${API_BASE_URL}/api/v1/task/sub/done/${subTaskId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization":`Bearer ${savedUser["jwtToken"]}`
                },
                body: JSON.stringify(subTask),
            });

            if (!response.ok) {
                throw new Error("Failed to update subtask status");
            }

            console.log(`Podzadatak ${subTaskId} je ${isApproved ? 'odobren' : 'odbijen'}`);

            const updatedSubTasksResponse = await fetch(`${API_BASE_URL}/api/v1/task/sub/${taskId}`);
            const updatedSubTasks = await updatedSubTasksResponse.json();

        } catch (error) {
            console.error('Error updating subtask status:', error);
        }
    };

    const approvePhoto = (subTaskId, subTask) => {
        updateSubTaskStatus(subTaskId, subTask, true);
    };

    const rejectPhoto = (subTaskId, subTask) => {
        updateSubTaskStatus(subTaskId, subTask, false);
    };

    return (
        <div className="task-details">
            <h2>{task.taskName}</h2>
            <ul className="photo-grid">
                {(
                    Array.from(filteredPhotos.entries()).map(([description, { subTaskId, photo, subTask }]) => (
                        <li key={subTaskId} className="photo-item">
                            <h4>{description}</h4>
                            <img src={photo.downloadURL} alt={photo.name} className="photo-img" />
                            <div className="photo-actions">
                                <p>Prihvatiti:</p>
                                <button onClick={() => rejectPhoto(subTaskId, subTask)} className="reject-btn">
                                    <FontAwesomeIcon icon={faXmark} style={{ fontSize: '20px' }} />
                                </button>
                                <button onClick={() => approvePhoto(subTaskId, subTask)} className="approve-btn">
                                    <FontAwesomeIcon icon={faCheck} style={{ fontSize: '20px' }} />
                                </button>
                            </div>
                        </li>
                    ))
                )}
            </ul>
        </div>
    );
}

export default TaskDetails;
